export default {
    "languages": {
        "russian": "Russian",
        "english": "English",
        "kazakh": "Kazakh"
    },
    "common": {
        "yes": "Yes",
        "no": "No",
        "success": "Success",
        "guest": "Guest",
        'back': "← Back",
        "now": "Now",
        "aMinuteAgo": "a minute ago",
    },
    "signin": {
        "signIn": "Login",
        "welcomeBack": "Welcome Back !",
        "introText": "iMean: your smart assistant in social networks.",
        "emailLabel": "Email Address",
        "inputPassword": "Input password",
        "passwordLabel": "Password",
        "forgotPassword": "Forgot password ?",
        "dontHaveAccount": "Don`t have an account?",
        "or": "or",
        "continue": "Continue",
        "signInEmail": "Sign in by mail",
        "signInGoogle": "Sign in with Google",
        "signInApple": "Sign in with Apple",
        "signInFacebook": "Sign in with Facebook",
        "signInInstagram": "Sign in with Instagram",
        "signInLinkedIn": "Sign in with LinkedIn",
        "linkFacebook": "Link Facebook account",
        "linkLinkedIn": "Link LinkedIn account",
        "linkInstagram": "Link Instagram account",
        "linkedFacebook": "Facebook already linked",
        "linkedInstagram": "Instagram already linked",
        "unlinkedLinkedIn": "Unhook LinkedIn",
        "unlinkedFacebook": "Unhook Facebook",
        "unlinkedInstagram": "Unhook Instagram",
        "privacy": "The terms of the <offerLink>Public offer</offerLink> and <privacyLink>Privacy policy</privacyLink> have been fully read by me, I understand all the conditions, and I agree to all the terms",
        "payment": "Payment order",
        "contacts": 'WhatsApp: +7 700 600 0001 \r\n Email: info@imean.io',
        "agreePrivacy": "Please select “☑” the checkbox next to the text regarding reading and agreeing to the Public Offer and the Policy.",
        "privacyTitle": "Privacy Policy",
        "offerTitle": "Public offer",
        "chooseLang": "Choose a language that is comfortable for you",
        "howThatWorkingBtn": "How does it work?",
        "welcomeModalTitle": "Welcome to IMEAN.IO",
        "welcomeModalText": "If you are here for the first time and do not know how our service works, you can click on the “To try” button to try the demo version of our application without authorization or click on “Authorize” to log in to your account.",
        "welcomeModalOkBtn": "To try",
        "welcomeModalCancelBtn": "Authorize",
        "login": "Log in",
        "submitSign": "Enter into your account using Google account or your email",
    },
    "signup": {
        "signUp": "Sign Up",
        "fullName": "Name",
        "passwordRequirements": "Ensure your password contains at least 8 characters - 1 uppercase, 1 lowercase, 1 number and 1 special symbol.",
        "haveAccount": "Already have an account?",
        "signUpGoogle": "Sign up with Google",
        "signUpApple": "Sign up with Apple",
        "signUpFacebook": "Sign up with Facebook",
        "signUpLinkedIn": "Sign up with LinkedIn",
        "lang": "Language",
        "submitSign": "Submit your sign in request and we will reach back asap.",
        "continue": "Get started",
        "copyrights": "© 2025 IMEAN Copyrights Reserved",
        "acceptPolicy": "Accept the policy and rules",
    },
    "welcome": {
        "welcome": "Welcome {{username}} to IMean!",
        "howWeWork": "How we work",
        "completeSurvey": "In order to successfully create a personal brand, it is important to develop a strategy.",
        "completeSurvey2": "Based on this strategy, a content plan will be formed and publications will be prepared that take into account your goals and preferences.",
        "proceed": "Proceed to Survey",
        "warning": "It is very important to answer the questions as completely as possible so that the strategy is closer to your expectations.",
        "warning2": "In the process of our interaction with you, we will adjust it, from our point of view, for more accurate personalization.",
        "verifyEmailTitle": "Confirm your e-mail",
        "verifyEmailText": "Enter the code from the email to confirm your email",
        "resendVerifyCode": "Get new code",
        "resendVerifyCodeSuccess": "Code successfully sent",
        "verifyEmailSuccess": "Mail successfully confirmed",
        "verifyEmailError": "Error! Wrong code may have been entered",
    },
    "assistant": {
        "header": "Assistant",
        "title": "Your personal assistant",
        "getSupport": "Support",
        "send": "Send",
        "shortcutSend": "Send: Ctrl+Enter",
        "shortcutPaste": "Paste: Ctrl+V",
        "emptyChat": "No messages yet",
        "pleaseWaitForResponse": "Please hold. I'm preparing a response...",
        "assistantInfo": "The assistant may make mistakes. We recommend checking important information.",
        "helloMessage": "Hello!\nI am your assistant and ready to help in various situations: prepare or reply to an email,\nshare the latest news, tell a joke, or even do a translation. I’m here to support\nyou in work, business, and many other matters. How can I assist you?",
        "textToGeneratePostFromAssistantMessage": "Generate a post based on this post with minimal changes",
        "createPostFromThisMessageBtn": "Create a post based on this post",
        "createsSeriesPostsFromThisMessageBtn": "Create a series of posts based on the context of this post",
        "addNewPostToSeries": "Add new post to series",
        "notEnoughPosts": "Not enough posts to create a series",
        "deleteSeriesElement": "Do you really want to delete this series item?",
        "createPostSuccess": "Post #{{count}} has been successfully generated!",
        "createPostError": "Error while creating post #{{count}}",
        "postTitlePrefix": "Series post #",
        "chatSettingsTitle": "Chat settings",
        "useYourFile": "Use your file",
        "useEmployeeFile": "Use Employee File",
        "useInternetSearch": "Use internet searches",
        "useInternetSearchingConfirm": "Please make sure that internet usage is disabled in the assistant’s settings to allow publishing posts through the assistant.",
        "assistantWarningInfo": "You need to upload a file to access this function",
        "assistantMakeQuestionsPopoverTitleTrue": "Create leading questions (Enabled)",
        "assistantMakeQuestionsPopoverTitleFalse": "Create leading questions (Off)",
        "assistantMakeQuestionsPopoverContent": "Enable the Assistant to create leading questions for you on your topic.",
        "assistantQuickFilePopoverTitleEmpty": "Quick file",
        "assistantQuickFilePopoverTitle": "Attached file",
        "assistantQuickFilePopoverInfo": "You can attach one quick file to your post for a more relevant response or to analyze the contents of the file.",
        "assistantSettingsInstructionTitle": "Test mode of the assistant's training.",
        "seriesPostsInstruction": "You can now create a series of related posts on a single topic. Each post will continue the previous one, forming a coherent narrative.\n" +
            "After generation, you can edit each post using the assistant until the entire series fits your needs.\n" +
            "Once ready, send the whole series to the «Create a post» section for scheduling and publishing.\n",
        "seriesPostsFromArrayInstruction": "Now you can create posts directly through the Assistant. Whether it’s a single post or a series of interconnected publications you like, you can instantly send them for publishing.",
        "assistantSettingsInstructionContent": "Provide information to the assistant, which it will learn to interact with you. (In addition to this mode, the advanced assistant will soon have additional very cool features).",
        "assistantFilesInstructionTitle": "Instructions for Using the Assistant",
        "assistantFilesInstructionContent": `You can provide information for the assistant, which it will review and use when interacting with you. Follow these steps:
1. Prepare a Word file (.doc or .docx) containing the information you want the assistant to consider.
2. If you want to add new data to existing information, include the new details in the same file while keeping all previously added information intact.
3. Upload the file through the designated section of the service.
Once the file is processed, the assistant will use the provided information in its responses and recommendations.`,
        "assistantFilesInstructionEmployeeContent": "You can provide information for the assistant, which will be used during interactions with you.\n" +
            "\n" +
            "To do this, follow these steps:\n" +
            " 1. Prepare a Word file (.doc or .docx) containing the information the assistant should consider.\n" +
            " 2. If you want to add new data to the existing ones, you need to upload a file with the added information.",
        "assistantInternetSearchInstructionTitle": "Instructions for Using Internet Queries in the Assistant",
        "assistantInternetSearchInstructionContent": "You now have the ability to use internet queries in the assistant and receive up-to-date information from the web.\n" +
            "\n" +
            "How to Enable Internet Queries?\n" +
            " 1. Activate the “Use Internet” checkbox in the assistant settings.\n" +
            " 2. Once activated, all subsequent queries during the current session will use the internet to generate responses.\n" +
            "\n" +
            "Important Limitations\n" +
            " 1. Internet access is active only during the current session. The checkbox must be reactivated when you log in again.\n" +
            " 2. Responses may take slightly longer as information is retrieved in real-time.",
        "uploadFile": "Upload file",
        "uploadNewFile": "Update file",
        "yourHaveFile": "You have an uploaded file.",
        "confirm": "Confirm",
        "fileUploadSuccess": "Successfully uploaded!",
        "post": {
            "postTitle": "Post",
            "generateImageLimitExceeded": "Image generation limit reached for this post (3 attempts)."
        },
        "postThemePlaceholder": "Enter the subject of the post",
        "postContentPlaceholder": "Enter the text of the post",
        "postHashtagsPlaceholder": "Enter hashtags for the post",
        "required": "Required",
        "getLeadingQuestions": "Getting Leading Questions",
        "waitLeadingQuestions": "Preparing Questions",
        "seeLeadingQuestions": "Open Leading Questions",
        "yourAnswerFromQuestionLabel": "Your answer to the question",
        "moveLeadingQuestionsToChatMessage": "Move questions to chat",
        "moveLeadingAnswersToChatMessage": "Move answers to chat",
        "reviseAnswer": "Revise Answer",
        "leadingQAPrompt1": "Question {{count}}: \"{{question}}\"\nand the user’s answer: \"{{answer}}\"\n\n",
        "leadingQAPrompt2": "Make additions to post #{{PostId}} \"{{postContext}}\" based on the user’s answers to the follow-up questions on the topic:\n{{prompt}}\nDo not modify the other posts in this set. Include all posts in your response.",
        "startRecording": "Start recording",
        "stopRecording": "Stop recording",
        "getAnswer": "Receive a answer",
        "waitAnswer": "Preparing a answer",
        "reGetAnswer": "Receive a new answer",
        "yourMessage": "Your message",
        "answerWithNumber": "Answer {{count}}: {{answer}}",
        "warningInternetSearchModalTitle": "Warning!",
        "warningInternetSearchModalText": "Internet search is currently enabled in your assistant settings. If you plan to use the post generation feature, we recommend temporarily disabling this function to ensure the assistant works correctly.",
        "warningInternetSearchModalSkipBtn": "Keep Search Enable",
        "warningInternetSearchModalAgreeBtn": "Disable Web Search",
        "sendChatMessageErrorText": "The previous request is still being processed. Please wait a few minutes. If the issue persists, contact Technical Support.",
    },
    "system_messages": {
        "request_for_editing_post": "⌬ Request to regenerate a post",
        "request_for_editing_post_with_info": "⌬ Regeneration of post #{{postNumber}} in view of the responses:\n\n{{text}}",
    },
    "profile": {
        "shareLocationExplanation": "Share approximate location (city/country) to improve scheduling.",
        "socialConnectionsTitle": "Social Connections",
        "hintConnectLinkedIn": "Connect your LinkedIn to publish",
        "hintConnectFacebook": "Connect your Facebook Business Page",
        "hintConnectInstagram": "Connect your Instagram Business account",
        "hintFacebookHelp": "Connect a Facebook Business Page to publish. Follow the steps in the guide below.",
        "hintInstagramHelp": "Make sure your Instagram is a Business account connected to a Facebook Page.",
        "unlinkLinkedinConfrim": "Do you really want to unlink your LinkedIn account?",
        "unlinkFacebookConfrim": "Do you really want to unlink your Facebook account?",
        "unlinkInstagramConfrim": "Do you really want to unlink your Instagram account?",
        "openFBDocsTitle": "Open the manual",
        "noPagesFB": "No Facebook pages",
        "noPagesLinkedIn": "No pages on LinkedIn",
        "cancelDelete": "Cancel the deletion",
        "accountWillBeDeleted": "Your account will be deleted",
        "recoverAccount": "Cancel the deletion",
        "removeAccountBtn": "Delete account",
        "yesRemoveAccount": "Yes, delete it.",
        "notRemoveAccount": "No, don't delete it",
        "removeAccountTitle": "Do you really want to delete the account?",
        "removingApproved": "Account deletion request successfully sent!",
        "recoverApproved": "Request to cancel account deletion has been successfully submitted!",
        "accountActionWait": "Wait...",
        "removeAccountDescription": "By clicking this button, you confirm that your data will be permanently deleted after 14 days. Once this period expires, After that, it will not be possible to restore the account.",
        "emptyReferrals": "You haven't invited anyone yet!",
        "status-accepted": "Invited",
        "status-pending": "Pending...",
        "status-gifted": "Reward received",
        "status-taken": "Invitation declined in favor of another",
        "close": "Close",
        "yourReferrals": "Your referrals",
        "reInvite": "Resend",
        "inviteSent": "The invitation to {{email}} has been sent",
        "inviteError": "There was an error when sending the invitation. This may be due to various reasons, perhaps this user is already registered.",
        "header": "Profile",
        "assistDescription": "Get the latest news and tips from an advanced assistant",
        "endSubscriptionDate": "Subscription expiration:",
        "endFreeSubscriptionDate": "The trial period will end:",
        "buySubscription": "Buy subscription",
        "subscriptionManagement": "Subscription management",
        "upgradeSubscription": "Update plan",
        "extendSubscription": "Extend subscription",
        "cancelSubscription": "Cancel subscription",
        "comingSoon": "It won't be long now...",
        "soon": "Soon...",
        "name": "Name",
        "position": "Position",
        "industry": "Field of activity",
        "login": "Login",
        "subscription": "Subscription until",
        "no": "No",
        "yes": "Yes",
        "lang": "Language generate",
        "gender": "Gender",
        "male": "Male",
        "female": "Female",
        "other": "Other",
        "timeZone": "Time zone",
        "organizationTitle": "Organization",
        "buttons": {
            "share": "Share",
            "reshare": "Reshare",
            "link": "Link",
            "unlink": "Unlink",
            "pages": "Pages",
            "help": "Help",
        },
        "linkAccount": "Link account",
        "linkedInError": "Re-assign the account",
        "inviteFriend": "Invite a friend:",
        "invite": "Invite",
        "timeZoneModalTitle": "Time zones",
        "inviteModalTitle": "Refer a Friend and Get Half a Month for Free!",
        "timeZoneModalText": `
            We have introduced the option to select a time zone (e.g., UTC+5) specifically for your convenience, allowing you to fine-tune the scheduling of your posts. This helps you better target your audience in the desired region and achieve maximum reach.
            <br>
            <b>Recommended posting times on LinkedIn:</b>
            \t•\tMonday: 8:00 AM to 10:00 AM
            \t•\tTuesday: 9:00 AM to 12:00 PM
            \t•\tWednesday: 10:00 AM to 12:00 PM
            \t•\tThursday: 9:00 AM to 11:00 AM
            \t•\tFriday: 9:00 AM to 12:00 PM
            <br>
            <b>Example usage:</b>
            If you are in Kazakhstan (UTC+5) and want to post content for an audience in the USA (e.g., New York, UTC-5), simply select the appropriate time zone. This will ensure that your posts appear at 9:00 AM New York time when the audience is most active.
            <br>
            <b>Major countries and their UTC offsets:</b>
            <b>Asia</b>
            <br>
            \t•\tKazakhstan (Almaty): UTC+5
            \t•\tChina (Beijing): UTC+8
            \t•\tIndia (New Delhi): UTC+5:30
            \t•\tJapan (Tokyo): UTC+9
            \t•\tSouth Korea (Seoul): UTC+9
            \t•\tIndonesia (Jakarta): UTC+7
            <b>Africa</b>
            \t•\tSouth Africa (Johannesburg): UTC+2
            \t•\tEgypt (Cairo): UTC+2
            \t•\tNigeria (Lagos): UTC+1
            \t•\tKenya (Nairobi): UTC+3
            \t•\tMorocco (Rabat): UTC+0
            <b>Latin America</b>
            \t•\tBrazil (São Paulo): UTC-3
            \t•\tArgentina (Buenos Aires): UTC-3
            \t•\tMexico (Mexico City): UTC-6
            \t•\tColombia (Bogotá): UTC-5
            \t•\tChile (Santiago): UTC-3
            <b>Europe</b>
            \t•\tUnited Kingdom (London): UTC+0
            \t•\tGermany (Berlin): UTC+1
            \t•\tFrance (Paris): UTC+1
            \t•\tItaly (Rome): UTC+1
            \t•\tSpain (Madrid): UTC+1
            <b>North America</b>
            \t•\tUSA (New York, Eastern Time): UTC-5
            \t•\tUSA (Los Angeles, Pacific Time): UTC-8
            \t•\tCanada (Toronto): UTC-5
            \t•\tCanada (Vancouver): UTC-8
            <b>Additional Notes:</b>
            Please note that some countries have multiple time zones. If your target audience is in a different country, we recommend checking the appropriate UTC offset for optimal posting times.
            You can check local times using tools like timeanddate.com.
            <br>
            Set your time zone and maximize your audience’s attention! 😊
      `,
        "inviteModalText": `
        Want to earn additional free days of using our service?<br>
        Simply invite a friend! Here’s how it works:
        <br>
        <ol>
        <li><b>1. Share their contact details:</b> Provide your friend’s email address if you think they would be interested in our service.</li>
        <li><b>2. We’ll send an email:</b> We’ll send your friend an email (with you in copy), introducing our service and letting them know you invited them. This ensures your friend knows it’s not spam or a scam.</li>
        <li><b>3. Get half a month free:</b> If your friend registers and subscribes to a paid plan, you’ll automatically receive 15 days of free access to the same plan your friend selected.</li>
        <li><b>4. Your friend benefits too:</b> Your friend will also receive a <b>30% discount on their first month</b> of using the service. It’s a win-win for everyone!</li>
        </ol>
        <br>
        If you have any questions, feel free to contact us at <a class='text-purple-800' href="mailto:info@imean.io">info@imean.io</a> — we’ll be happy to help!
        `,
        "shareGeoDataButtonTitle": "Share location",
        "reShareGeoDataButtonTitle": "Update location",
        "sharedGeoDataSuccess": "You have successfully updated your location on the IMEAN.IO server",
        "sharedGeoDataError": "An error occurred while updating the location on the IMEAN.IO server",
        "selectFacebookPage": "Select a Facebook page",
        "selectLinkedInPage": "Select a LinkedIn page",
        "helpForFacebook": "Help with Facebook",
        "fbPagesInfoLinking": "To connect your Facebook account to our service, make sure you have a Facebook Page, not just a personal Profile." +
            "<br/>" +
            "<br/>" +
            "How to create a Page? Check the “Helpful Tips” section in the main window for guidance.",
        "helpForInstagram": "Help with Instagram",
        "instInfoLinking": "To connect your Instagram account to our service, make sure you have an Instagram Business Account." +
            "<br/>\n" +
            "<br/>\n" +
            "How to create a Business Account? Check the “Helpful Tips” section in the main window for guidance.",
    },
    "subscriptionPlans": {
        "header": "Rates",
        "Strategy": "Strategy",
        "ContentPlan": "Content plans",
        "LeadingQuestions": "Leading questions",
        "Post": "Posts",
        "Theme": "Themes",
        "PostImages": "Post images",
        "free": "Free",
        "paid": "Premium",
        "assistant": "Advanced Assistant",
        "infoButton": "Description of functionality",
        "promoCodeTitle": "Promo code",
        "havePromoCode": "Got a promo code?",
        "promoCodeError": "Incorrect promo code or promotion expired",
        "modalTitle": "Functionality of the IMEAN.IO service:",
        "modalText": `
            iMean helps you easily and efficiently create LinkedIn, Facebook, Instagram posts using artificial intelligence. Our service offers:
            
             <b>• AI-Powered Post Creation:</b>
            Our service utilizes advanced artificial intelligence algorithms to generate unique content tailored to your professional identity and goals. You receive posts that align with your style, audience, and key topics in your field. This helps you stand out among competitors and build your personal brand.
            
             <b>• Instant and Scheduled Posting:</b>
            You can publish your posts on LinkedIn, Facebook, Instagram immediately or schedule them for a more convenient time. Scheduled posting allows you to maintain regular activity on the platform even when you’re busy. This feature ensures that your content reaches your audience at the most effective time, increasing engagement and impact.
            
             <b>• Assistant:</b>
            Our intelligent assistant is ready to answer your questions, help generate ideas for posts, translate text into other languages, draft business emails, and even suggest strategies for interacting with your audience. Communicate with it in a dialogue format, just like with a personal consultant who is always at your disposal. Moreover, you can ask the assistant to write a post and publish it directly on LinkedIn, Facebook, Instagram, saving your time and simplifying the publishing process.
            
             <b>• Voice Input:</b>
            Forget about typing — simply speak, and our service will convert your words into text. This feature is especially useful when you’re short on time or want to capture an idea on the go. Voice input works quickly and accurately, allowing you to focus on content rather than on typing.
        `,
        "submit": "Ok",
        "unlimitedRate": "Unlimited functionality",
        "assistantRate": "Unlimited Functional + personal AI assistant",
        "freeRate": "Free trial period for 14 days",
        "active": "Active",
        "offerExpire": "The offer will expire",
        "offerOver": "The offer's over",
        "subscribeExpired": "Subscription expired",
        "subscribeExtended": "Subscription successfully renewed!",
        "rememberMyCard": "Memorize card",
        "rememberMyCardPopoverTitle": "Payment Instruction for Users",
        "rememberMyCardPopoverText": "For your convenience, by selecting the checkbox, you can save your card and avoid entering it again for future payments. We do not store or process your card details—this is handled by FreedomPay, a global payment orchestration platform that ensures secure and reliable transactions.\n" +
            "\n" +
            "If you don’t have your card with you, you can pay using Apple Pay, Google Pay, or Samsung Pay. In this case, you do not need to select the checkbox to save the card.",
        "removeMyCardBtn": "Delete card",
        "cardDeleted": "The card has been successfully deleted!",
        "cardDeleteError": "Server error when deleting a card!",
        "confirmDeleteCard": "Do you really want to delete your payment card?",
        "confirmExtendSubscribe": "Confirm your subscription renewal",
    },
    "publicationCalendar": {
        "calendarTitle": "Publication calendar",
        "loading": "Loading data...",
        "today": "Today",
        "navigationTitles": {
            "past60": "-2m.",
            "past30": "-1m.",
            "past10": "-10d.",
            "past7": "-1w.",
            "past5": "-5d.",
            "past3": "-3d.",
            "past1": "-1d.",
            "future1": "+1d.",
            "future3": "+3d.",
            "future5": "+5d.",
            "future7": "+1w.",
            "future10": "+10d.",
            "future30": "+1m.",
            "future60": "+2m.",
        },
        "postStatuses": {
            "published": "The post has been successfully published!",
            "error": "Publication error:",
            "pending": "Pending publication...",
        },
        "postTypes": {
            "personal": "(personal)",
            "quickPersonal": "Quick post",
            "planPersonal": "Content plan post",
            "quickEmployee": "Quick post (employee)",
            "planEmployee": "Content plan post (employee)",
            "other": "Other type"
        },
        "goToPost": "Go to post",
        "legend": "Legend",
        "contentTypes": {
            "contentPlan": "Content plan post",
            "quickPost": "Quick post"
        },
        "noPosts": "No posts",
        "filters": {
            "byUser": "Filter by user:",
            "selectUser": "Select user",
            "allUsers": "All users"
        },
        "toolbar": {
            "today": "Today",
            "past": "Past:",
            "future": "Future:",
            "view": "View:",
            "viewOptions": {
                "day": "Day",
                "week": "Week",
                "month": "Month",
                "year": "Year",
                "custom": "Custom"
            }
        },
        "messages": {
            "loadingPosts": "Loading posts…",
            "noPosts": "No posts"
        },
        "legendLabels": {
            "quickPersonal": "Quick post (personal)",
            "plannedPersonal": "Content plan post (personal)",
            "quickEmployee": "Quick post (employee)",
            "plannedEmployee": "Content plan post (employee)"
        },
    },
    "survey": {
        "survey": "Survey",
        "recording": "Recording voice.. Click to stop recording",
        "type": "or type your answer here...",
        "wait": "Please wait, we are saving your answers and generating information. It might take some time",
        "clear": "Clear",
        "submit": "Submit",
        "tapToStart": "Click to dictate your answer",

        "title": "Please fill in the information to create content",

        "inputLabelName": "What is your name?",
        "inputPlaceholderName": "Enter your name",
        "inputInfoName": "This name will be used in the content",

        "inputLabelIndustry": "Industry",
        "inputPlaceholderIndustry": "The industry you work in",
        "inputInfoIndustry": "If your industry is not listed, you can enter it manually",

        "inputLabelPosition": "Position",
        "inputPlaceholderPosition": "Your position",
        "inputInfoPosition": "If your position is not listed, you can enter it manually",

        "textLabelWorkExperienceAndSkills": "Work experience and key skills",
        "textPlaceholderWorkExperienceAndSkills": "A brief description of your work experience, key skills and competencies, as well as projects you are proud of.",

        "textLabelPersonalityHobby": "Personal interests and hobbies",
        "textPlaceholderPersonalityHobby": "Information about hobbies and interests that can be included in posts to make them more human and authentic.",

        "textLabelSocialActivity": "Social activity and community involvement",
        "textPlaceholderSocialActivity": "Information about groups or communities you are actively involved in (e.g., unions, volunteering, professional groups).",

        "textLabelShortGoals": "Short-term career goals (1-2 years)",
        "textPlaceholderShortGoals": "Defining the immediate professional goals you want to achieve in the short term. This can include promotions, learning new skills, or successfully completing major projects.",

        "textLabelLongGoals": "Long-term career goals (3-5 years)",
        "textPlaceholderLongGoals": "In which direction do you want to grow over a longer period. What roles or positions do you see for yourself in the future? These goals help you focus on the strategic steps needed to achieve these career aspirations.",

        "textLabelUniqueTradeRelations": "Unique selling proposition (USP)",
        "textPlaceholderUniqueTradeRelations": "How do you stand out from other professionals in your field? This may include unique skills, approaches, or achievements that make you a valuable specialist in the job market.",

        "textLabelAchievements": "Awards and achievements",
        "textPlaceholderAchievements": "Professional awards, recognitions, certifications, or praise from colleagues and management that highlight your experience and contributions to the industry. This can include successful projects, leadership, or innovative solutions.",

        "textLabelProjects": "Projects and initiatives in progress",
        "textPlaceholderProjects": "Information about the current projects or initiatives you are working on that may be of interest to the audience. This shows your activity and engagement in the professional environment.",

        "textLabelStrongSides": "Your unique strengths",
        "textPlaceholderStrongSides": "Key competencies, strong skills, and personal qualities that help you successfully perform your job and excel in your professional activities. This may include leadership qualities, problem-solving abilities, communication skills, etc.",

        "textLabelWeakSides": "Weaknesses",
        "textPlaceholderWeakSides": "Aspects that you consider as areas for growth or improvement. These could be skill gaps or knowledge areas you want to work on in the future to become a more effective professional.",

        "selectLabelExperience": "Experience level",
        "selectPlaceholderExperience": "Choose Your experience level",

        "checkboxLabelThemes": "Topics for discussion",

        "checkboxLabelGoalsPublicLinkedIn": "Goals of social media publishing",
    },
    "home": {
        "welcomeBack": "Welcome back, ",
        "logout": "Logout",
        "logoutConfirm": "Do you really want to log out of your account?",
        "support": "Technical support",
        "postsCalendar": "Publication Calendar",
        "guideline": "Useful tips",
        "homeNavTitle": "Home",
        "contentPlanNavTitle": "Контент-план",
        "createPostNavTitle": "Быстрые публикации",
        "personalAssistantNavTitle": "Ассистент",
        "strategyNavTitle": "Стратегия",
        "contentPlan": "Create content plan",
        "personalAssistant": "Personal Assistant",
        "strategy": "Digital strategy",
        "moderation": "Moderation",
        "alertsManagement": "Alert management",
        "achievements": "Achievements",
        "myAchievements": "My Achievements",
        "createPost": "Create a post",
        "formatPost": "Publication format",
        "linkSocials": "Link social accounts",
        "profile": "Profile",
        "personalBrandStrategy": "A personal brand is a public image of a person leading a professional activity that appears in the minds of the target audience",
        "profileTitle": "Information about your profile, subscriptions, and invited friends",
        "contentPlanTitle": "This section stores information about upcoming posts",
        "createPostTitle": "Here you can quickly create and instantly publish a post.",
        "assistantTitle": "In dialogue mode, your personal assistant can translate text, write emails, and much more.",
        "strategyTitle": "This is where a strategy is created for you.",
        "moderationTitle": "Here you can manage the posts of other users",
        "subscriptionDaysLeft": "Number of days until subscription expires: {{days}}",
        "role": "Ambassador",
        "friend": "Friend",
        "welcome": "Welcome",
        "useYourInnerVoice": "Use your inner voice",
        "publicationCalendar": "Publication Calendar",
        "publicationCalendarDesc": "Plan and track your posts effortlessly with a clean calendar.",
        "instantPost": "Instant Post",
        "instantPostDesc": "Stay connected anytime with reliable infrastructure for uninterrupted communication.",
        "contentPlanLong": "Plan your content effectively and transform the way you work.",
        "personalAssistantDesc": "Gain insights and make data-driven decisions with advanced tools.",
        "moderationDesc": "Streamline communication and foster teamwork with efficient tools.",
        "analytics": "Analytics",
        "analyticsDesc": "Scale effortlessly with reliable and flexible infrastructure."
    },
    "personalBrand": {
        "needSurveyText": "For more accurate creation of your content, you need to take a survey",
        "coffee": `This might take 5-7 minutes.\r\nHow about a cup of invigorating coffee for some inspiration while the strategy is being formed?`,
        "header": "Digital strategy",
        "newStrategy": "Create new brand strategy",
        "Name": "Name",
        "Occupation/Title": "Title",
        "Short Bio": "Short Bio",
        "Accolades & Awards": "Accolades & Awards",
        "Strengths": "Strengths",
        "Weaknesses": "Weaknesses",
        "Passions": "Passions",
        "Values": "Values",
        "What Sets You Apart": "What Sets You Apart From The Peers",
        "Unique Benefits You Can Provide": "Unique Benefits You Can Provide",
        "Determine Who You are Trying to Reach and Communicate With": "Determine Who You are Trying to Reach and Communicate With",
        "Understand Their Needs, Wants, and Challenges": "Understand Their Needs, Wants, and Challenges",
        "How Should Daniel Address These Needs and Challenges": "How Should {{username}} Address These Needs and Challenges",
        "Colors": "Colors",
        "Imagery": "Imagery",
        "Personal Logo or Signature": "Personal Logo or Signature",
        "Areas of Expertise": "Areas of Expertise",
        "Content Formats": "Content Formats",
        "Content Themes": "Content Themes",
        "Engagement Strategy": "Engagement Strategy",
        "Short-term Goals (1-2 years)": "Short-term Goals (1-2 years)",
        "Long-term Goals (3-5 years)": "Long-term Goals (3-5 years)",
        "Feedback Channel": "Feedback Channel",
        "Adaptation Strategy": "Adaptation Strategy",
        "Conclusion": "Conclusion",
        "pdf": "Download PDF"
    },
    "sendPassword": {
        "header": "Forgot Password",
        "title": "Please enter your email address to receive a password reset link.",
        "placeholder": "Email address",
        "sendCode": "Send link",
        "return": "Back"
    },
    "newPassword": {
        "wrongEmail": "Invalid email address.",
        "noMatch": "Passwords do not match.",
        "header": "Create New Password",
        "passwordRequirements": "Ensure your password contains at least 8 characters - 1 uppercase, 1 lowercase, 1 number and 1 special symbol.",
        "placeholderCreate": "Create a new password",
        "placeholderConfirm": "Confirm password",
        "continue": "Continue"
    },
    "post": {
        "titlePage": "Compose Post",
        "improveBut": "Improve",
        "saveBut": "Save",
        "showMore": "more",
        "rollUp": "up",
        "textToGenerateAnotherPost": "Write a similar one or a sequel to this post",
        "at": "at",
        "needSurveyText": "To more accurately create your digital content, you need to take a survey",
        "needSurveyRepeatText": "For the next generation of instant posts, you need to take a survey that will help you generate better posts",
        "leadingQuestions": "Leading questions",
        "noLeading1": "In order to write personalized post press Generate to have insightful questions for the perfect post",
        "noLeading2": "If you’re unsure what to write about right now, click the “Generate” button to see guiding questions that might help you find a direction for your post. Otherwise, feel free to ignore it.",
        "loading": "Loading...",
        "generate": "Generate",
        "headerPost": "Post",
        "headerCreate": "Create Post",
        "suggestion": "Post suggestion",
        "published": "Published",
        "notpublished": "Not published",
        "broken": "Error",
        "planned": "Scheduled for",
        "hashtagSuggestion": "Hashtag suggestions",
        "mediaSuggestion": "Visual Recommendations",
        "image": "Media files",
        "noImage": "No media files!",
        "noImageInfoNotDrag": "Drag the file(s) here or click to select",
        "noImageInfoWithDrag": "Release to load",
        "bigFileSize": "The file size is too large. Please choose another image up to 10mb",
        "bigMediaListSize": "The total weight of the media files exceeds {{size}}mb. Please select other media files up to {{size}}mb in total size.",
        "maxVideoSize": "The file size is too large. Please choose another video up to 300mb",
        "uploadImage": "Upload Image",
        "processingImage": "Plase wait, we are processing image",
        "save": "Save",
        "generateImage": "Generate Image",
        "generatingImage": "Generating Image",
        "generating": "We are generating your post",
        "remove": "Remove",
        "addVideo": "Upload Video",
        "removeVideo": "Remove Video",
        "removeImages": "Remove Images",
        "removeSingleMediaConfirm": "Are you sure you want to delete this media file?",
        "removeAllMediaConfirm": "Are you sure you want to delete all media files?",
        "maxVideoDuration": "The video duration is too long. Please choose another video up to 10min",
        "dragActive": "Drag the file(s) here or click to select",
        "onDrag": "Release to load",
        "dragInfo": "You can upload media files: videos up to 200mb and duration up to 10 minutes and images up to 8mb each.",
        "notificationFilesForPlatformsTitle": "Image Recommendations",
        "notificationFilesForPlatformsDescription": "Since different social networks have their own image guidelines, below is information on image recommendations for each platform:\n" +
            " \n" +
            "LinkedIn\n" +
            "​•​Recommended size: 1200 x 627 pixels (aspect ratio 1.91:1).\n" +
            "​•​Minimum size: 552 x 368 pixels.\n" +
            "​•​Maximum size: 7680 x 4320 pixels.\n" +
            " \n" +
            "Facebook\n" +
            "​•​Recommended size: 1200 x 630 pixels.\n" +
            "​•​Minimum width: At least 630 pixels.\n" +
            " \n" +
            "Instagram\n" +
            "​•​Recommended size: 1080 x 1080 pixels.\n" +
            "​•​Square image: 1080 x 1080 pixels (1:1).\n" +
            "​•​Portrait: 1080 x 1350 pixels (4:5).\n" +
            "​•​Landscape: 1080 x 566 pixels (1.91:1).\n" +
            " \n" +
            "Note: Social network requirements for posts, including images, may change over time, so it is recommended to check the status of your post after publishing.",
        "postGenerateImageLimit": "Maximum number of image generation per post 3 attempts.",
        "postGenerateImageLeft": "You have attempts left:",
        "selectSocialsMedia": "Choose social media",
        "apply": "Apply",
        "visibleLogoTitle": "Display logo",
        "logoScales": {
            "SM": "Small",
            "MD": "Medium",
            "LG": "Large",
        },
        "logoPositions": {
            "TOP_LEFT": "Top left",
            "TOP_RIGHT": "Top right",
            "BOTTOM_LEFT": "Bottom left",
            "BOTTOM_RIGHT": "Bottom right",
            "LEFT": "Left",
            "RIGHT": "Right",
            "CENTER": "Center",
            "TOP": "Top",
            "BOTTOM": "Bottom",
        },
        "videoToInstagramInfo": "Videos can only be uploaded to Instagram. Please use \"Mostly compatible\" format. ",
        "videoOrImagesOnly": "Reels only support video content. Only include either images or videos.",
    },
    "contentPlan": {
        "header": "Content Plan",
        "week": "Week",
        "add": "Click + to select social networks",
        "selectNetworks": "Select social networks",
        "frequency": "Frequency",
        "elementsTitle": "Select or add elements for this weeks content",
        "custom": "Write your custom content requests here",
        "create": "Create content plan",
        "tokenError": "At least one social network must be linked to generate it",
        "strategyError": "You have not generated a personal strategy",
        "needSurveyText": "To create a content plan, you must complete a survey",
        "goToSurveyBtnText": "Take the survey",
        "selectWeekDaysTitle": "Select which days of the week to generate content for",
        "brands": {
            "instagram": "Instagram",
            "linkedin": "LinkedIn",
            "facebook": "Facebook"
        },
        "readiness": "Readiness status",
        "readyToPublish": "Ready to publish",
        "notReadyHint": "Content plan not ready",
        "previewCompanyPage": "Company Page",
        "previewBusinessPage": "Business Page",
        "emptyAlt": "Empty content plan",
        "languages": {
            "russian": "in Russian",
            "english": "in English"
        }
    },
    "organization": {
        "managedByOrganization": "This profile is managed by the organization",
        "viewFile": "View file",
        "uploadFile": "Upload file",
        "replaceFile": "Replace file",
        "replaceLogo": "Replace logotype",
        "aboutOrganization": "About the organization",
        "contacts": "Contacts",
        "name": "Name",
        "establishmentYear": "Establishment Year",
        "email": "E-Mail",
        "phone": "Phone",
        "website": "Website",
        "address": "Address",
        "credentials": "Requisites",
        "BANK": "BANK",
        "BIC": "BIC",
        "BIN": "BIN",
        "IIK": "IIK",
        "KBE": "KBE",
        "generalDirector": "General director",
    },
    "postPage": {
        "cards": {
            "postTitle": "Quick post",
            "platforms": "Platforms",
            "linkAcc": "Link accounts to enable",
            "schedule": "Schedule",
            "localTime": "Uses your local time",
            "whatPostSay": "What should the post say?",
            "characters": "Characters",
            "generationOptions": "Generation options",
            "formatPostTitle": "Format",
            "languagesPost": "Languages",
            "lengthPost": "Length",
            "emojisPost": "Emojis",
            "modelPost": "Model",
            "targetScheduleTitle": "Target & Schedule",
            "when": "When",
            "autoOptimizationTitle": "Auto-Optimization",
            "postContentTitle": "Post Content",
            "hashtagsTitle": "Hashtags",
            "mediaSuggestionsTitle": "Media Suggestions",
            "mediaTitle": "Media",
            "mediaRequirementsTitle": "Media Requirements",
            "mediaRequirementsBody": "Recommended image/video formats and platform-specific limits.",
            "bestTimeRecommendations": "Best-time recommendations",
            "autoRescheduleOnConflict": "Auto-reschedule on conflict",
            "detailsTitle": "Your Notes",
            "tipsTitle": "Tips",
        },
        "toolbar": {
            "emojisOptions": {
                "none": "None",
                "few": "Few",
                "more": "More",
            },
            "modelOptions": {
                "default": "Default",
                "creative": "Creative",
                "formal": "Formal",
            },
        },
        "hint": {
            "hintText": "Short, clear context improves quality. Include audience and goal.",
            "shortcutSend": "Send: Ctrl+Enter",
            "shortcutPaste": "Paste: Ctrl+V",
            "previewHint": "Preview your post in social media",
        },
        "brands": {
            "instagram": "Instagram",
            "linkedin": "LinkedIn",
            "facebook": "Facebook"
        },
        "buttons": {
            "startRecording": "Start recording",
            "stopRecording": "Stop recording",
            "copy": "Copy",
            "save": "Save",
            "edit": "Edit",
            "uploadImage": "Upload image",
            "removeVideo": "Remove video",
            "addVideoReels": "Add video (Reels)",
            "generate": "Generate",
            "removeImages": "Remove images",
            "saveFooter": "Save",
            "publishFooter": "Publish",
            "clear": "Clear",
            "settings": "Settings",
            "remember": "Remember",
            "refresh": "Refresh",
            "hide": "Hide",
            "show": "Show",
        },
        "placeholders": {
            "post": "Write something engaging…",
            "hashtags": "#marketing #b2b #casestudy",
            "media": "Suggest visuals, themes, or B-roll…",
            "addDetails": "Add details, key points, links…",
            "detailsPlaceholder": "Add context, links, bullet points…",
        },
        "dropzone": {
            "noImagesYet": "No images yet",
            "dropFilesToUpload": "Drop files to upload",
            "dragDropOrClick": "Drag & drop or click to upload",
            "hint": "PNG/JPG up to 8MB each, total 80MB.",
            "browserNoVideoSupport": "Your browser does not support the video tag.",
            "largeTotalWarning": "Large total media size — consider compressing.",
            "noLeadingYet": "No leading questions yet",
        },
        "footer": {
            "draftSaved": "Draft saved a minute ago • Auto-save on"
        },
        "misc": {
            "companyPage": "Company Page",
            "imageLabel": "Image"
        },
        "message": {
            "cannotEditPublished": "Published post can't be edited",
        },
    },
    "functions": {
        "maxTextLength": "The {{limit}} limit on the maximum number of characters has been exceeded",
        "minTextLength": "Minimum number of characters {{limit}}",
        "noText": "Text field cannot be empty",
        "newPasswordFail": "Password change error",
        "copiedFromService": "Copied from the service",
        "noData": "No data",
        "apply": "Apply",
        "generate": "Generate",
        "generating": "Generating...",
        "successfullyGenerated": "Successfully generated!",
        "successfullyFinished": "Successfully finished!",
        "successfullyUploaded": "Successfully uploaded!",
        "successfullySaved": "Successfully saved!",
        "successfullySendToGenerate": "Successfully started the process of generating!",
        "wrong": "Something went wrong",
        "loading": "Loading...",
        "sending": "Sending...",
        "microphone": "Error accessing microphone, please check your device or give permission",
        "generatingPost": "Please wait, generating Post",
        "generatingContentPlan": "Please wait, generating Content Plan",
        "generatingBrand": "Please wait, generating Strategy",
        "loadingLeading": "Loading leading questions",
        "copied": "Copied !",
        "pastedFromClipboard": "Pasted from clipboard",
        "savingAnswersForStrategy": "Saving answers and generating strategy",
        "changesSaved": "Changes saved",
        "close": "Close",
        "loggedIn": "Successfully logged in!",
        "registered": "Successfully registered!",
        "incorrectCreds": "Failed to sign in! Please check your email.",
        "limitReached": "Action limit reached, used {{count}} of {{max}} by your rate",
        "recoveryRequested": "If the email address was entered correctly, we have sent a password reset link to it.",
        "newPassword": "Password was reset",
        "error": "Error",
        "errorPleaseCallSupport": "Error, please contact tech support.",
        "warning": "Warning",
        "wrongLayout": "Wrong layout, need change language",
        "maxImages": "Maximum number of images - 6",
        "beta": "Beta",
        "minMediaForInstagramPostMessage": "You must upload or generate at least one media file to post to Instagram!",
        "characterLimitError": "{{network}} limits the maximum number of characters to ({{limit}})",
        "pleaseEditPost": "Please edit your post to meet the character limit requirements.",
        "editPost": "Edit post",
        "collapse": "Collapse",
        "expand": "Expand",
        "next": "Next",
        "previous": "Back",
        "onThePage": "on page",
        "copy": "Copy",
        "continue": "Continue",
        "accessAfterAuth": "Available only after authorization!",
        "successfullyMoved": "Successfully relocated!",
        "selectUser": "Please select a user",
        "allUsers": "All users",
        "sortBy": "Sort by",
        "date": "Date",
        "user": "User",
        "ascending": "Ascending",
        "descending": "Descending",
        "filterByUser": "Filter by user",
        "generateDist": "Generate",
        "name": "Name",
        "reloadPageMessage": "Generation takes more than anticipated. You can refresh the page.",
        "reloadPage": "Refresh",
        "edit": "Edit",
        "searchPosts": "Post search",
        "perImageTooLarge": "Each image must be under 8MB",
        "totalImagesTooLarge": "Total images size must be under 80MB",
        "somethingWentWrong": "Something went wrong",
        "pageSize": "Show by",
        "order": "Sorting",
    },
    "socials": {
        "header": "Social networks",
        "linkAccounts": "Link social network accounts to enable auto-posting"
    },
    "plancard": {
        "generated": "Post generated",
        "notGenerated": "Post not generated",
        "approved": "Approved",
        "notApproved": "Not approved",
        "onModeration": "On moderation",
        "publish": "Publish post",
        "approve": "Approve post",
        "approveAgain": "Publish again",
        "disapprove": "Send for revision",
        "cancel": "Cancel publication",
        "cantCancelPublished": "The post has already been published and cannot be undone",
        "checkingPublish": "Checking the publication status…",
        "hide": "Hide publication",
        "hiddeConfrim": "Do you really want to hide this publication?",
        "successfullyHidden": "The post has been successfully hidden!",
    },
    "posts": {
        "header": "Posts",
        "generatePost": "Generate post",
        "postDescription": "Share with us the main idea or context of the planned post. You can use the microphone.",
        "postDetails": "Details",
        "settingsSaved": "Settings successfully saved",
        "postDate": "Publication date",
        "publish": "Publish",
        "create": "Create",
        "cancel": "Cancel",
        "regenerate": "Regenerate post",
        "limit": "The limit of the rate has been reached. You can subscribe to a paid rate to continue using the service.",
        "unknownError": "An error occurred. Please contact the technical support section of the service and describe the problem. We will do our best to solve the problem quickly.",
        "notLinked-linkedin": "Link a LinkedIn account to be able to publish posts",
        "notLinked-facebook": "Link a Facebook account to be able to publish posts",
        "notLinked-instagram": "Link your Instagram account to be able to publish posts",
        "notSelectedFacebookPage": "Select the Facebook page in your profile to publish posts to Facebook",
        "snErrorMessage": "The post you are attempting to publish requires the linking of social networks that you do not have or may have unlinked. Please go to your profile and link the social networks that this post uses and try again.",
        "goToRate": "Go to rates",
        "goToProfile": "Go to profile",
        "goToSupport": "Go to support",
        "chooseFormatTitle": "Choose format of publication",
        "acceptFormat": "Accept",
        "formatExampleText": "Example",
        "createAnotherPost": "Create a similar post",
        "seePost": "View post",
        "formats": "Formats",
        "languages": "Languages",
        "selectLanguages": "Select languages",
        "formatSettings": "Format settings",
        "formatPublication": "Format publication",
        "noTextToFormat": "No text to format",
        "selectAtLeastOneLanguage": "Select at least one language",
        "formatSuccess": "Text formatted successfully",
        "formatError": "Error formatting text",
        "postModelTitle": "Format model",
        "modelBasic": "Basic",
        "generatedPost": "Generated Post Text",
        "modelAdvance": "Advanced",
        "selectedLanguages": "Selected languages",
        "postLengthTitle": "Post length (words)",
        "postEmojisTitle": "The abundance of emojis in the post",
        "useEmojisTitle": "Use emojis",
        "kazGenerateWarningMessage": "Now generation in Kazakh language is in beta testing, but we are working on improving the quality of generation in Kazakh language",
        "multiLanguagePostsGeneratePlaceholder": "Select languages for generating multi-language posts (If left blank, the post will be generated in your selected language in your profile)",
        "multiLanguagePostsGenerateTitle": "Generation of multilingual posts",
        "multiLanguagePostsGenerateDescription": "If you want to generate a post in multiple languages, select the languages in the field below. \n" +
            "When selecting a language, take into account the order in which you select the languages (The post will be generated in the order in which you select the languages). \n" +
            "If you leave the field empty, the post will be generated in the language you selected in your profile.",
        "postStatusesInfoTitle": "Information on publication statuses",
        "postStatusModerated": "Promoted",
        "postsListEmptyText": "The list of posts is empty, click “Create a post” to create a post",
        "postLanguageModelTitle": "Language model selection",
        "postModels": {
            "default": "Standard",
            "advance": "Advanced",
        },
        "memoizeChoice": "Memorize the selection",
        "noPostsTitle": "No posts yet",
        "noPostsHint": "Create your first post to see it here.",
    },
    "support": {
        "header": "Technical support",
        "supportCardTitle": "Open a Ticket",
        "sectionTitle": "Section",
        "describeTitle": "Describe the issue",
        "placeholderDescribe": "What happened? Steps to reproduce, expected result, environment…",
        "attachmentTitle": "Attachments (images or video)",
        "contactCard": {
            "title": "Contact",
            "hint": "We typically reply within 1 business day.",
        },
        "troubleShooting": {
            "title": "Troubleshooting",
            "hint": "If something looks off after a new release, try clearing the offline cache and reloading the app.",
            "alert": {
                "title": "Clear cached files and refresh",
                "description": "This will remove the cached UI bundle from your device and reload the page.",
                "buttonClear": "Clear cache & reload",
                "footerTip": "Tip: Include screenshots or a short screen recording in your ticket for faster resolution.",
            },
        },
        "sectionLabel": "Select a section",
        "messageLabel": "Describe problem or suggestion",
        "fileLabel": "Attach file",
        "send": "Send",
        "uploadFile": "Uploaded files",
        "removeFile": "Remove",
        "sections": {
            "home-page": "Home-page",
            "profile-page": "Profile",
            "content-plan": "Content-plan",
            "publication": "Publication",
            "personal-assistant": "Personal-assistant",
            "personal-branding": "Personal-strategy",
        },
        "dropzone": {
            "attachment": "Drag & drop here or click to upload (up to 6 files)",
        },
        "buttons": {
            "chooseFiles": "Choose files",
            "clear": "Clear",
            "send": "Send",
            "remove": "Remove",
        },
        "clearCacheBtnTitle": "Clear cache",
        "clearCacheDescription": "If you are having problems with outdated data, click the “Clear cache” button to update your information.",
        "clearCacheSuccess": "Cache successfully cleared!",
        "ifQuestionGetSupport": "If you have any questions or issues, please visit the <a class='text-primary' href='/support'>Support</a> section.",
    },
    "moderation": {
        "header": "Moderation",
        "postsOnModerationEmpty": "The list of actual posts for moderation is empty!",
        "postsOnArchiveEmpty": "The list of archived posts is empty!",
        "onModeration": "On moderation",
        "archive": "Archive",
        "unreadModerationCountMessage": "You have {{count}} posts to moderate!",
        "goToModeration": "Go to moderation",
        "emptyModerationListTitle": "No posts awaiting moderation",
        "emptyModerationListHint": "New posts requiring review will appear here.",
        "emptyArchiveTitle": "Archive is empty",
        "emptyArchiveHint": "Approved or declined posts will appear here.",
    },
    "alerts": {
        "createNotification": "Create Notification",
        "editNotification": "Edit Notification",
        "viewNotification": "View Notification",
        "hintCreateAlerts": "Create internal alerts and auto-post jobs for selected employees.",
        "history": "History",
        "title": "Title",
        "description": "Description",
        "type": "Type",
        "theme": "Theme",
        "link": "Link",
        "text": "Text",
        "fromPostLink": "Link to post",
        "postText": "Text of post",
        "status": "Status",
        "author": "Author",
        "recipient": "Recipient",
        "createdAt": "Created At",
        "actions": "Actions",
        "create": "Create",
        "update": "Update",
        "cancel": "Cancel",
        "enterPostLink": "Enter link to post",
        "enterPostText": "Enter text of post",
        "enterTitle": "Enter notification title",
        "enterDescription": "Enter notification description",
        "selectType": "Select notification type",
        "info": "Info",
        "warning": "Attention",
        "danger": "Important",
        "selectTheme": "Select notification theme",
        "alert": "Notification",
        "suggestion": "Suggestion",
        "createPost": "Creating a post",
        "titleRequired": "Title is required",
        "descriptionRequired": "Description is required",
        "typeRequired": "Type is required",
        "themeRequired": "Theme is required",
        "employeesRequired": "The list of recipients is mandatory",
        "createSuccess": "Notification created successfully",
        "editSuccess": "Notification updated successfully",
        "fetchError": "Error fetching notifications",
        "success": "Success",
        "error": "Error",
        "createError": "Error creating notification",
        "editError": "Error updating notification",
        "yes": "Yes",
        "no": "No",
        "hideConfirmTitle": "Hide Notification",
        "hideConfirmDescription": "Are you sure you want to hide this notification from users?",
        "hiddenSuccess": "Notification was successfully hidden",
        "visibleSuccess": "Notification is now visible to users",
        "postCreatedSuccess": "Post successfully created!",
        "postCreatedForUsers": "Post successfully created for employee {{employeeName}} in {{socialNetwork}}",
        "visibilityError": "Error changing notification visibility",
        "notVisibleTooltip": "This notification is no longer visible to users",
        "viewNotificationTooltip": "View notification details",
        "employees": "Employees",
        "newNotificationsCreated": "New notifications created",
        "newNotificationsCreatedDesc": "Created {{count}} new notifications for added employees",
        "noData": "No data to display",
        "prompt": "Prompt",
        "enterPrompt": "Enter your prompt here",
        "cardFormat": {
            "title": "Format settings",
            "language": "Language:",
            "model": "Model:",
            "length": "Length:",
            "emojis": "Use emojis:",
        },
        "buttons": {
            "formattingOptions": "Formatting options",
            "selectAll": "Select All",
            "clear": "Clear",
        },
        "placeholder": {
            "title": "Enter a short title",
            "description": "What should this notification say?",
            "theme": "Select theme",
            "employees": "Select employees",
            "prompt": "Optional: guidance for generation",
            "link": "Paste a link to an article or page",
            "sourceText": "Paste or write the source text (max 2000 chars)",
            "language": "Select languages",
        },
        "hint": {
            "title": "Please enter a title (2–200 chars)",
            "description": "Please enter a description (2–2000 chars)",
            "theme": "Please select a theme",
            "employees": "Select at least one employee",
        },
        "themeOption": {
            "alert": "Alert",
            "suggestion": "Suggestion",
            "createPost": "Create Post",
        },
        "cardPost": {
            "linkTitle": "From Link:",
            "sourceTextTitle": "Source text:",
            "generatePost": "Generated post:",
            "labelPrompt": "Prompt",
        },
    },
    "hww": {
        "regTitle": "Registration in the service",
        "regSubtitle": "Register in the service",
        "strategyTitle": "Strategy Creation",
        "strategySubtitle": "Take the questionnaire and the AI will provide a personal strategy",
        "planTitle": "Creating content plan",
        "planSubtitle": "Based on the strategy, the AI will offer you a content plan",
        "postTitle": "Publishing posts",
        "postSubtitle": "Based on your strategy and content plan, the AI will suggest post ideas for you"
    },
    "weekDays": {
        "Monday": "Monday",
        "Tuesday": "Tuesday",
        "Wednesday": "Wednesday",
        "Thursday": "Thursday",
        "Friday": "Friday",
        "Saturday": "Saturday",
        "Sunday": "Sunday"
    },
    "months": {
        "January": "January",
        "February": "February",
        "March": "March",
        "April": "April",
        "May": "May",
        "June": "June",
        "July": "July",
        "August": "August",
        "September": "September",
        "October": "October",
        "November": "November",
        "December": "December"
    },
    "notifications": {
        "title": "Notifications",
        "open": "Open notifications",
        "unread": "Unread notifications",
        "read": "Read notifications",
        "empty": "No notifications",
        "allEmpty": "No notifications to display",
        "markAsRead": "Mark as read",
        "goToPost": "Go to post",
        "postCreationError": "Error creating post",
        "employeeNoSocials": "Could not create post for {{employeeName}}. Please ensure at least one social network is linked for them.",
        "types": {
            "info": "Information",
            "warning": "Warning",
            "danger": "Important"
        },
        "themes": {
            "alert": "Alert",
            "suggestion": "Suggestion",
            "create_post": "New post",
        },
        "yourHaveUnreadNotifications": "You have unread notifications"
    },
    "validation": {
        "enterName": "Please enter your full name",
        "nameValid": "Looks good!",
        "nameRequired": "Please enter your full name",
        "enterEmail": "Enter your email address here",
        "emailValid": "Email looks good!",
        "emailInvalid": "Please enter a valid email address",
        "emailRequired": "Email is required",
        "emailDomainMustContainLetters": "Email comain must contain letters",
        "emailDomainExtensionTooShort": "Email domain extension too short",
        "emailDomainExtensionMustContainLetters": "Email domain extension must contain letters",
        "emailCannotContainConsecutiveDots": "Email cannot contain consecutive dots",
        "enterPassword": "Enter your password",
        "passwordValid": "Password looks good!",
        "passwordInvalid": "Your password doesn't meet the requirements",
        "passwordRequired": "Password is required",
        "passwordTooShort": "Password must be at least 8 characters long",
        "passwordTooLong": "Password must be shorter than 128 characters",
        "passwordNeedsAnUppercase": "Password needs at least one uppercase letter",
        "passwordNeedsALowercase": "Password needs at least one lowercase letter",
        "passwordNeedsANumber": "Password must contain at least one number",
        "passwordNeedsASpecialCharacter": "Password must contain at least one special character",
        "passwordCannotHaveSpaces": "Password cannot contain spaces",
        "passwordIsTooCommon": "Password contains common patterns and is too weak",
        "fixValid": "Check the form fields",
    },
    "achievements": {
        "goToMyAchievements": "Go to my achievements",
        "earnedLevel": "Your current level",
        "earnedExperience": "Experience gained",
        "earnedCoins": "Coins gained",
        "unlockedCountAchievements": "Unlocked {{opened}} out of {{count}} achievements",
        "completedOnPercent": "{{percent}}% complete",
        "completedOnCount": "Completed {{completed}} out of {{count}}",
        "benefits": "Benefits",
        "fetchingError": "Failed to retrieve achievement data. Server connection error, try again later",

        "intern": {
            "title": "Intern",
            "description": "Account created - your journey begins here!"
        },
        "activist": {
            "title": "Activist",
            "description": "10 posts in one month - you're finding your voice!"
        },
        "inspirer": {
            "title": "Inspirer",
            "description": "20 posts reached - your contributions are inspiring others!"
        },
        "ambassador": {
            "title": "Ambassador",
            "description": "30 posts achieved - you're now a recognized leader in our community."
        },
        "ambassadorplus": {
            "title": "Ambassador+",
            "description": "40 posts and beyond - you're shaping the conversation at the highest level!"
        }
    },
    "achievementLevel": {
        "Intern": "Intern",
        "Activist": "Activist",
        "Inspirer": "Inspirer",
        "Ambassador": "Ambassador",
        "AmbassadorPlus": "Ambassador +",
        "Description": {
            "Intern": "Welcome! We're so glad you have joined us!",
            "Activist": "Your influence is getting apparent!",
            "Inspirer": "Impressive level of social media influence",
            "Ambassador": "You're shaping the views of others",
            "Ambassadorplus": "Ultimate rank"
        }
    },
    "postDistribution": {
        "postDistributionForm": {
            "title": "Title",
            "prompt": "Instruction / Prompt",
            "languageLabel": "Language",
            "employees": {
                "employeesLabel": "Employees",
                "placeholder": "Select employees",
                "selectAll": "Select all",
                "clear": "Clear",
            },
            "placeholder": {
                "enterTitle": "Enter a short title",
                "enterPrompt": "What should each post include? (tone, call-to-action, key points)",
                "chooseLanguage": "Choose languages",
            },
            "hint": {
                "title": "Please enter a title (2–200 chars)",
                "prompt": "Please enter a description (2–2000 chars)",
                "language": "Select 1–3 languages",
            },
            "linkTab": {
                "title": "Link",
                "label": "Source Link",
                "placeholder": "Paste a link to an article or page",
            },
            "textTab": {
                "title": "Text",
                "label": "Source Text",
                "placeholder": "Paste or write the source text (max 8000 chars)",
            },
        },
        "buttons": {
            "generating": "Generating…",
            "generate": "Generate for Selected",
        },
        "postDistributionTagName": "Post Distribution",
        "sendToRecipient": "Send to user: ",
        "sendingInProgress": "Sending the post to the user...",
        "postLanguages": "Generation languages",
        "characterMinLimitError": "Post content must be at least 25 characters",
        "characterMaxLimitError": "Post content must be smaller. Current character limit: ",
        "hashtagsRequired": "Hashtags are required",
        "fileSizeLimitExceeded": "File size is too big.",
        "submissionSuccess": "Post submitted successfully!",
        "submissionFailure": "Post submission failed.",
        "regenerationSuccess": "Post regenerated successfully!",
        "regenerationFailure": "Post regeneration failure!",
        "title": "Title",
        "enterTitle": "Enter a title",
        "promptInstruction": "Instruction for post generation",
        "enterDescription": "Enter description",
        "link": "Link",
        "fromPostLink": "From post link",
        "enterPostLink": "Enter post link",
        "text": "Text",
        "postText": "Post text",
        "enterPostText": "Enter post text",
        "employees": "Employees",
        "employeesRequired": "Select at least one employee",
        "selectAll": "Select all",
        "clear": "Clear",
        "selectOneToThreeLanguages": "Please select from 1 to 3 languages",
        "selectLanguages": "Select languages",
        "regeneratePrompt": "Didn't like the post? Tell us what to do!"
    },
    "postRegeneration": {
        "postRegenerationPlaceholder": "Text your prompt here to get a more tailored result, or leave it empty. We will just re-generate the post."
    },
    "errors": {
        "notFound": "Oops! Nothing to see here",
    },
    "navigations": {
        "backHome": "Back to Home",
    },
    "analytics": {
        "menu": "Analytics",
        "title": "Instagram Analytics",
        "noAccounts": "No connected Instagram accounts.",
        "emptyLead": "Connect a business Instagram account to view follower, posts and engagement metrics.",
        "connectAccount": "Connect account",
        "account": "Account",
        "filters": "Filters",
        "period": "Period",
        "days7": "7 days",
        "days30": "30 days",
        "followers": "Followers",
        "followersTotalSub": "Total",
        "media": "Media",
        "mediaTotalSub": "Total publications",
        "likesSum": "Likes (sum)",
        "commentsSum": "Comments (sum)",
        "last10Posts": "For last 10 posts",
        "lastPostsAll": "For last {{count}} merged posts",
        "followersByDay": "Followers by day",
        "posts": "Posts",
        "recentPosts": "Recent posts",
        "recentPostsAll": "Recent posts (all accounts)",
        "date": "Date",
        "post": "Post",
        "likes": "Likes",
        "comments": "Comments",
        "link": "Link",
        "open": "Open",
        "noPosts": "No posts",
        "refresh": "Refresh",
        "moderatorMode": "Moderator mode",
        "allAccounts": "All accounts",
        "moderatorTag": "Moderator",
        "reach": "Reach",
        "engagement": "Accounts engaged",
        "profileViews": "Profile views",
        "metricFollowers": "Followers",
        "metricPosts": "Posts",
        "metricReach": "Reach",
        "metricEngaged": "Accounts engaged",
        "metricProfileViews": "Profile views",
        "metricSelector": "Metric",
        "downloading": "Downloading...",
        "downloadPdf": "Download PDF report",
        "insights": "Insights"
    },

    "mediaInsights": {
        "title": "Media insights",
        "periodWeek": "Last 7 days",
        "period30d": "Last 30 days",
        "back": "Back",
        "openPost": "Open post",
        "rangeTitle": "Range",
        "likesByDay": "Likes by day",
        "commentsByDay": "Comments by day",
        "metrics": {
            "comments": {
                "title": "Comments",
                "description": "Number of comments on your post."
            },
            "follows": {
                "title": "Follows",
                "description": "The number of new follows to your account."
            },
            "likes": {
                "title": "Likes",
                "description": "Number of likes on your post."
            },
            "profile_activity": {
                "title": "Profile actions",
                "description": "Sum of all actions taken on your profile when users interact with this content."
            },
            "profile_visits": {
                "title": "Profile visits",
                "description": "Number of visits to your profile."
            },
            "reach": {
                "title": "Accounts reached",
                "description": "Number of unique accounts that saw this post at least once. This metric is an estimate."
            },
            "saved": {
                "title": "Saves",
                "description": "Number of saves of your post."
            },
            "shares": {
                "title": "Shares",
                "description": "Number of shares of your post."
            },
            "total_interactions": {
                "title": "Post interactions",
                "description": "Number of likes, saves, shares and comments on your post minus unlikes, unsaves and deleted comments."
            },
            "views": {
                "title": "Views",
                "description": "Number of plays or impressions of your post."
            }
        }
    }

}
